<script>
import DocumentReviewRiskBanner from '@/V2/documents/document-view/document-review-agent/DocumentReviewRiskBanner.vue';
import { getVerificationTitle } from '@/V2/documents/document-view/document-review-agent/utils';
import UrlsDisplayer from '@/V2/components/UrlsDisplayer.vue';

export default {
  components: {
    DocumentReviewRiskBanner,
    UrlsDisplayer,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return { getVerificationTitle };
  },
};
</script>

<template>
  <div
    class="document-review-agent-details d-flex flex-column i-p-10 i-gap-10"
    data-testid="document-review-agent-details"
  >
    <!-- header -->
    <div class="header d-flex align-items-start i-gap-6">
      <div class="d-flex flex-column flex-grow-1">
        <div class="title d-flex i-text-button-2 i-text-neutral-120">
          {{ item.title }}
        </div>
        <div class="subtitle d-flex i-text-body-3 i-text-neutral-110">
          {{ item.subtitle }}
        </div>
      </div>
    </div>

    <!-- details -->
    <div class="body d-flex flex-column i-gap-10">
      <document-review-risk-banner
        :risk="item.result"
      ></document-review-risk-banner>
      <div class="rationale i-text-body-3 i-text-neutral-120">
        {{ item.rationale }}
      </div>
      <urls-displayer :urls="item.urls" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.document-review-agent-details {
  .rationale {
    line-height: 18px !important;
  }
}
</style>
